<div class="flex flex-col gap-y-4 justify-center">
  <div class="flex items-center gap-x-2">
    <tui-icon icon="tuiIconSettings"></tui-icon>
    <h2 class="font-bold text-2xl">Обновление ПО</h2>
  </div>
  <div>
    Нажмите "Активировать" или закройте все вкладки с приложением для завершения
    обновления
  </div>
  <button size="m" tuiButton (click)="applyUpdateAndReloadAll()">
    Активировать
  </button>
</div>
